import { render, staticRenderFns } from "./ItemsAlertBox.vue?vue&type=template&id=726de6b8&scoped=true"
import script from "./ItemsAlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemsAlertBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemsAlertBox.vue?vue&type=style&index=0&id=726de6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726de6b8",
  null
  
)

export default component.exports